import { Link } from 'react-router-dom'

function DeveloperCard({ developer }) {
  return (
    <div className="bg-white border border-neutral-200 rounded-xl p-6 hover:border-neutral-300 hover:shadow-lg transition-all group">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-neutral-100 to-neutral-200 flex items-center justify-center text-neutral-600 font-bold text-2xl flex-shrink-0">
          {developer.initials}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-neutral-900 mb-1 group-hover:text-primary-600 transition-colors">
            {developer.name}
          </h3>
          <p className="text-sm text-neutral-600">
            {developer.projectCount} {developer.projectCount === 1 ? 'project' : 'projects'} on Beaver
          </p>
        </div>
      </div>

      <p className="text-sm text-neutral-600 leading-relaxed mb-4 line-clamp-3">
        {developer.description}
      </p>

      <div className="flex items-center justify-between pt-4 border-t border-neutral-100">
        <div className="flex items-center gap-4 text-xs text-neutral-500">
          <div className="flex items-center gap-1">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <span>{developer.location}</span>
          </div>
          <div className="flex items-center gap-1">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            <span>{developer.unitsDelivered}+ units</span>
          </div>
        </div>
        <Link
          to={`/projects?developer=${developer.id}`}
          className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1"
        >
          View projects
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </div>
  )
}

export function FeaturedDevelopers() {
  const developers = [
    {
      id: 'dev1',
      name: 'Urban Living Developments',
      initials: 'UL',
      projectCount: 3,
      location: 'Auckland',
      unitsDelivered: 250,
      description: 'Specializing in sustainable, community-focused apartment living in central Auckland. Award-winning design and quality construction with a focus on first home buyers.',
    },
    {
      id: 'dev2',
      name: 'Coastal Properties Group',
      initials: 'CP',
      projectCount: 2,
      location: 'Wellington',
      unitsDelivered: 180,
      description: 'Premium waterfront developments combining stunning views with modern amenities. Known for delivering on time and exceeding quality expectations.',
    },
    {
      id: 'dev3',
      name: 'Heritage Homes Ltd',
      initials: 'HH',
      projectCount: 4,
      location: 'Christchurch',
      unitsDelivered: 320,
      description: 'Family-owned developer with 25 years experience. Focus on creating warm, liveable spaces that blend contemporary design with practical family living.',
    },
  ]

  return (
    <section className="py-24 bg-white">
      <div className="container-custom">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-light text-neutral-900 mb-4">
              Quality developers you can trust
            </h2>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
              Every developer on Beaver is verified and committed to transparency.
              Browse their projects and track progress from consent to completion.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {developers.map((developer) => (
              <DeveloperCard key={developer.id} developer={developer} />
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/developers"
              className="inline-flex items-center gap-2 px-6 py-3 bg-neutral-900 text-white rounded-xl hover:bg-neutral-800 transition-colors font-medium"
            >
              View all developers
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
